import type { ComponentType } from 'react'
import { redirect, type RouteObject } from 'react-router-dom'
import { AppPaths } from '@/config/app-paths'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { AlertsPermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
  perm: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Alerts route page export "${exportName}" not found`)
  }
  return { Component: createPermissionGuardedPage(perm, Page, { mode: 'any' }) }
}

export const alertsRoutes: RouteObject[] = [
  {
    path: 'admin/attendance-alerts',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/alerts-schedules-page'),
        'AlertsSchedulesPage',
        AlertsPermissions.manageSchedules,
      ),
  },
  {
    path: 'admin/attendance-alerts/:scheduleId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/alerts-schedule-editor-page'),
        'AlertsScheduleEditorPage',
        AlertsPermissions.manageSchedules,
      ),
  },
  {
    path: 'admin/attendance-alerts-runs',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/alerts-runs-page'),
        'AlertsRunsPage',
        AlertsPermissions.viewHistory,
      ),
  },
  // Alias: some bookmarks omit the /admin prefix on admin.amglobal.co
  {
    path: 'attendance-alerts-runs',
    loader: () => redirect(AppPaths.adminAttendanceAlertRuns),
  },
]
